import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { AutomationStep } from "@/types/Automation";
import { LAYLO_CONTACT_TYPE_OPTIONS } from "../constants";
import type { StepNodeData } from "../types";

export function LayloCreateSubscriberFields({
  step,
  onStepDataChange,
}: {
  step: AutomationStep;
  onStepDataChange: StepNodeData["onStepDataChange"];
}) {
  const contactType = (step.data?.contactType as string) || "phone";

  return (
    <div className="p-4 space-y-3 nodrag" onPointerDownCapture={(e) => e.stopPropagation()}>
      <p className="text-xs text-muted-foreground">
        Subscribes the lead to your Laylo account using the selected contact info.
      </p>
      <div className="space-y-2">
        <Label className="text-xs text-violet-800">Subscribe with</Label>
        <Select
          value={contactType}
          onValueChange={(val) => onStepDataChange({ stepId: step.id, field: "contactType", value: val })}
        >
          <SelectTrigger className="text-sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {LAYLO_CONTACT_TYPE_OPTIONS.map((opt) => (
              <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
